namespace $.$$ {

	$mol_style_define( $bog_vmap_app_publish, {

		flex: { direction: 'row', shrink: 0 },
		align: { items: 'center' },
		gap: $mol_gap.text,

		Note: {
			color: $mol_theme.shade,
			font: { size: '.75rem' },
			whiteSpace: 'nowrap',
		},

		Copy: {
			font: { family: 'monospace', size: '.8rem' },
			whiteSpace: 'nowrap',
		},

	} )

}
